import PropTypes from "prop-types";
import ContentSection from "@shared/content/ContentSection";
import ContentBlock from "@shared/content/ContentBlock";
import { CONTENT_TYPES, SECTION_WIDTHS } from "@shared/constants/contentTypes";
import { SPACING } from "@shared/constants/designSystem";

const BasePage = ({
  title,
  subtitle,
  description,
  showAccentLine = true,
  children,
}) => {
  return (
    <article className={SPACING.LARGE}>
      <ContentSection width={SECTION_WIDTHS.NORMAL} gradientType="sectionLight">
        <header className={SPACING.DEFAULT}>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-2 sm:space-y-4 pt-2 sm:pt-4 pb-4 sm:pb-6">
              <div className="space-y-2 sm:space-y-3">
                <div className="inline-block">
                  <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light tracking-wide text-gray-900 dark:text-white">
                    {title}
                  </h1>
                  {showAccentLine && (
                    <div className="flex justify-center mt-1 sm:mt-2">
                      <div className="w-16 sm:w-20 h-1 bg-gradient-to-r from-gray-300 to-gray-500 dark:from-gray-600 dark:to-gray-400 rounded-full"></div>
                    </div>
                  )}
                </div>
              </div>
              {subtitle && (
                <p className="text-lg sm:text-xl md:text-2xl text-gray-600 dark:text-gray-300 leading-relaxed">
                  {subtitle}
                </p>
              )}
              {description && (
                <p className="text-sm sm:text-base text-gray-500 dark:text-gray-400 leading-relaxed">
                  {description}
                </p>
              )}
            </div>
          </div>
        </header>
        <ContentBlock type={CONTENT_TYPES.TEXT}>{children}</ContentBlock>
      </ContentSection>
    </article>
  );
};

BasePage.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  showAccentLine: PropTypes.bool,
  children: PropTypes.node,
};

export default BasePage;
